// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

// import { gsap, TweenLite } from "../node_modules/gsap";

// import { TickerShared } from "../core/Ticker";
export default class TestAnimationJitter {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }


    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {





        //app.ticker.maxFPS = 60;
        //vf.Ticker.shared.maxFPS = 60;

        const la = new vf.gui.Label("抖一抖");
        const la1 = new vf.gui.Label("抖一抖1");
        const la2 = new vf.gui.Label("抖一抖2");



        const rect = new vf.gui.Rect();
        rect.lineWidth = 1;
        rect.width = 600;
        rect.height = 500;
        rect.x = 0;
        rect.y = 300;
        uiStage.addChild(rect);
        la.style.backgroundColor = 0x00ff00;
        la.x = 0;
        la.width = 200;
        la.y = 300;
        la.pivotX = 0;
        la1.style.backgroundColor = 0x00ff00;
        la1.x = 100;
        la1.width = 200;
        la1.y = 400;
        la1.pivotX = 100;
        la2.style.backgroundColor = 0x00ff00;
        la2.x = 100;
        la2.width = 200;
        la2.y = 500;
        la2.pivotX = 100;
        const sss = new vf.gui.Rect();
        sss.color = 0xffffff;
        sss.x = 300;
        sss.width = 100;
        sss.height = 100;
        sss.lineColor = 0xff00cc;
        sss.lineWidth = 1;
        // uiStage.addChild(sss);
        // uiStage.addChild(la);
        uiStage.addChild(la1);
        // uiStage.addChild(la2);

        // const gs = gsap.timeline({
        //     repeat: 2, repeatDelay: 0, yoyo: true, paused: true,
        //     onStart: () => {
        //         console.log("start");
        //     },
        //     onRepeat: () => {
        //         console.log("repeat");
        //     },
        //     onComplete: () => {

        //         const t = vf.gui.Utils.now();
        //         console.log("complete", t - time);
        //         time = t;
        //     },
        //     onReverseComplete: () => {
        //         console.log("反播放完成");
        //     },
        //     onUpdate: () => {
        //         // slider.value = t2.currenTimer;
        //     }
        // });
        // gs.to(la, { x: 100, duration: 1 });

        let time = vf.gui.Utils.now();
        const t2 = new vf.gui.TimeLine({
            repeat: 0,
            paused: true,
            delay: 0,
            yoyo: false,
            onStart: () => {
                console.log("startT");
            },
            onRepeat: () => {
                console.log("repeatT");
            },
            onComplete: () => {

                const t = vf.gui.Utils.now();
                console.log("正面播放完成ggg", t - time);
                time = t;
            },
            onReverseComplete: () => {
                console.log("反播放完成ggg");
            },
            onUpdate: () => {
                // slider.value = t2.currenTimer;
            }
        });
        t2.to(la1, 2000, {
            x: 200, ease: vf.gui.Easing.Linear.None,
            onUpdate: function () {
                // console.log("wwwwwwwww");
            }
        }, 4000)
        t2.to(la1, 5000, {
            y: 500, ease: vf.gui.Easing.Linear.None,
            onUpdate: function () {
                console.log(la1.x);
            }
            , onComplete: () => {

                console.log("x == 500");
            }
        }, 2000)
        // t2.to(la1, 2000, {
        //     x: 200, ease: vf.gui.Easing.Linear.None,
        //     onUpdate: function () {
        //         // console.log("wwwwwwwww");
        //     }
        // }, 1000)                  //0
        // .to(la2, 500, { alpha: 0 }, -1000)
        // .to(sss, 500, {
        //     y: 800, ease: vf.gui.Easing.Cubic.InOut,
        //     onUpdate: function () {
        //         // console.log("ssssssss");
        //     }
        // }, 1000)            //1000
        // .to(sss, 500, { x: 500 }, 1500)            //1000
        // .to(sss, 1000, { x: 500 }, 2000)
        // .to(la1, 2000, { y: 800 }, -3000)
        // .to(la1, 2000, { scaleX: 0.5 }, -1000)


        this.getButton('play', () => {
            t2.play();
            // gs.play();
        }, uiStage, 15, 0);
        this.getButton('Reverse', () => {
            t2.reverse();
            // gs.reverse();
        }, uiStage, 15, 0);
        this.getButton('Pause', () => {
            t2.pause();
            // gs.pause();
            //t2.addPause(3000, null, null);
        }, uiStage, 15, 0);

        this.getButton('Resume', () => {
            t2.resume();
        }, uiStage, 15, 0);
        this.getButton('Seek', () => {
            t2.seek(100);
        }, uiStage, 15, 0);


        var t = new vf.gui.Tween(la);
        t.easing(vf.gui.Easing.Quadratic.InOut)
        // t.repeat(999);
        t.to({ x: 500 }, 2000);
        this.getButton('纯tweenplay', () => {
            t2.play() //!t.reversed());
        }, uiStage, 15, 0);

        this.getButton('纯tween reverse', () => {
            // t.reverse() //!t.reversed());
            t2.onStart = () => {
                console.log("d");
            }
        }, uiStage, 15, 0);
        this.getButton('Release', () => {
            t2.release();
        }, uiStage, 15, 0);

        const slider = new vf.gui.Slider();
        slider.vertical = false;
        slider.thumb = "assets/skin/Slider/thumb.png";
        slider.track = "assets/skin/Slider/track.png";
        slider.tracklight = "assets/skin/Slider/tracklight.png";
        slider.maxValue = t2.duration;
        slider.style.width = 500;
        slider.style.height = 10;
        slider.style.bottom = 50;
        slider.style.left = 150;
        slider.value = 0;
        uiStage.addChild(slider);

        let count = 0
        slider.on(vf.gui.Interaction.ComponentEvent.CHANGEING, (slider: vf.gui.CheckBox, curValue: number) => {
            if (count == 0) {
                count++;
                return;
            }
            // if (t2.paused) {
            //     t2.seek(curValue);
            // }

            // console.log(count, curValue, slider);

        });

    }
    private aaa: any;
    private hasAdd: boolean = false;


    private start: any;
    private step(timestamp: any) {
        if (!this.start) this.start = timestamp;
        var progress = timestamp - this.start;
        if (progress < 200000) {
            this.aaa.x += 10
            if (this.aaa.x >= 500) {
                this.aaa.x = 0;
            }
            window.requestAnimationFrame(this.step.bind(this));
        }
    }

    private posY = 15;
    private getButton(title: string, fun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 24;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, () => {
            console.log(title);
            fun();
        });
        target.addChild(button);
        this.posY = this.posY + 35 + y;
    }
}

